module.exports = __webpack_public_path__ + "img/sld_mfm_invs_8_dark.ceb2430a.svg";